<button #trigger class = "ui-notification-button ui-square-button" (click) = "eventOpenOptions()" >
    <i class="ui-icon uii-bell" matba [matBadge]="unreadCount" [matBadgeHidden]="!unreadCount" matBadgeOverlap="false" matBadgeColor="primary" matBadgeSize="small"></i>
</button>

<ng-template #menuTemplate>
    <div class = "ui-notification-container" @transformMenu>
        <div class = "ui-header-container">
            <div class = "ui-header-icon ui-panel">
                <i class = "ui-icon uii-bell"></i>
            </div>
            <div class = "ui-header-title-container">
                <div class = "ui-header-title">
                    Notificações
                </div>
            </div>
            <div class = "ui-header-options-container">
                <i class = "ui-icon uii-times" (click) = "eventCloseOverlay()"></i>
            </div>
        </div>
        <div class = "ui-notification-menu-container">
            <mat-button-toggle-group hideSingleSelectionIndicator class = "ui-notification-read-selector" [value]="readType" (change)="readType = $event.value" name="readType" aria-label="Lido ou não">
                <mat-button-toggle class="ui-button-label" value="all">Todas</mat-button-toggle>
                <mat-button-toggle class="ui-button-label" value="unread">Não lidas ({{unreadCount}})</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <cdk-virtual-scroll-viewport itemSize="50" class="ui-notification-actions-container">
                <div *cdkVirtualFor="let notification of notifications | filterByReadType:readType:loading"
                class="ui-notification-item"
                [class.unread]="notification && !notification.read"
                (click)="notification && eventMarkNotificationAsRead(notification._id)">

                <ng-container *ngIf="notification; else skeletonTemplate">
                    <div class="ui-notification-item-header">
                        <p>{{notification.title}}</p>
                    </div>
                    <div class="ui-notification-item-content">
                        <p>{{notification.description}}</p>
                    </div>
                    <div class="ui-notification-item-footer">
                        <span>{{notification.timeAgo}}</span>
                    </div>

                    <div class="ui-notification-item-actions">
                        <button class="ui-square-button" matTooltip="Excluir notificação" matTooltipClass="notif-tooltip" (click)="$event.stopPropagation();eventRemoveNotification(notification._id)">
                            <i class="ui-icon uii-trash"></i>
                        </button>
                        <button *ngIf="!notification.read" class="ui-square-button" matTooltip="Marcar como lida" matTooltipClass="notif-tooltip" (click)="$event.stopPropagation();eventMarkNotificationAsRead(notification._id)">
                            <i class="ui-icon uii-eye"></i>
                        </button>
                        <button *ngIf="notification.action" class="ui-square-button" matTooltip="Ver detalhes" matTooltipClass="notif-tooltip" (click)="$event.stopPropagation();eventHandleAction(notification.action)">
                            <i class="ui-icon uii-sliders"></i>
                        </button>
                    </div>
                </ng-container>

                <ng-template #skeletonTemplate>
                    <div class="ui-notification-item-loading">
                        <app-skeleton-loader type="line" [size]="1" [width]="['12vw']"></app-skeleton-loader>
                        <app-skeleton-loader type="line" [size]="1" [width]="['15vw']"></app-skeleton-loader>
                        <app-skeleton-loader type="line" [size]="1" [width]="['4vw']"></app-skeleton-loader>
                    </div>
                </ng-template>

            </div>
        </cdk-virtual-scroll-viewport>
    </div>
</ng-template>
